import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "./i18n";

const API = process.env.REACT_APP_BACKEND_URL;

export const Newsletter = () => {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return toast.error(t("nl.invalid"));
    setBusy(true);
    try {
      await axios.post(`${API}/api/newsletter`, { email });
      toast.success(t("nl.ok"), { description: t("nl.okd") });
      setEmail("");
    } catch (err) {
      toast.error(t("nl.retry"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="relative px-5 md:px-10 py-24 md:py-36 bg-[#FF2A2A] text-black overflow-hidden">
      <div className="absolute -right-[10vw] -top-[6vw] f-goth text-[48vw] leading-none text-black/10 pointer-events-none select-none">OG</div>
      <Reveal className="relative grid md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-7">
          <div className="f-mono text-xs tracking-[0.3em] mb-6">(04) — {t("nl.kicker")}</div>
          <h2 className="f-disp uppercase text-[16vw] md:text-[8vw] leading-[0.82]">{t("nl.t1")}<br />{t("nl.t2")}</h2>
        </div>
        <form onSubmit={submit} className="md:col-span-5" data-testid="newsletter-form">
          <p className="text-sm md:text-base mb-8 max-w-sm font-medium">{t("nl.text")}</p>
          <div className="flex items-center border-b-2 border-black">
            <input
              data-testid="newsletter-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ton@email.com"
              className="flex-1 bg-transparent h-16 text-xl md:text-2xl placeholder:text-black/50 outline-none f-mono"
            />
            <button data-testid="newsletter-submit-button" disabled={busy} className="group h-14 w-14 bg-black text-white flex items-center justify-center hover:bg-white hover:text-black transition-colors disabled:opacity-50" aria-label="S'inscrire">
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </form>
      </Reveal>
    </section>
  );
};
